import React from 'react'
// Styles
import './mrc.style.css'
// Actions
import { Base_API } from '../../_actions/matcher'
// Images
import RewardImg from '../../assets/images/rewards/reward_2.png'

function MyReward_Card({ data, onSelected }) {

    return (
        <div className="myrwc-container" onClick={() => onSelected(data.id)}>
            {/* left */}
            <div className="banner-wrapper">
                <img className='banner' src={`${!!data && data.Cover}`} />
            </div>
            {/* middle */}
            <div className="center">
                <h3 className="pd-name t-bold t-normal-size">{!!data && data.Title}</h3> 
                <p className="exp-date t-lowgray t-normal">ใช้ได้ถึง -</p>
            </div>
            {/* bottom */}
            <div className="right">
                {/* <button className='use-coup'>ใช้คูปอง</button> */}
            </div>
        </div>
    )
}

export default MyReward_Card